import z from "zod";
import { MoneyScheme } from "./money";
import { DiscountType } from "./enums/DiscountType";

export const DiscountPercentageScheme = z.object({
  type: z.literal(DiscountType.PERCENTAGE),
  percentage: z.number(),
});

export const DiscountAmountScheme = z.object({
  type: z.literal(DiscountType.AMOUNT),
  amount: MoneyScheme,
});

export const DiscountScheme = z.discriminatedUnion("type", [
  DiscountPercentageScheme,
  DiscountAmountScheme,
]);

export type DBDiscount = z.infer<typeof DiscountScheme>;
export type PercentageDiscount = z.infer<typeof DiscountPercentageScheme>;
